module.exports = __webpack_public_path__ + "img/syukyaku-top-012.ca9925f8.jpg";